export enum UserStatus {
  ACTIVE = 'ATIVO',
  INACTIVE = 'INATIVO'
}
